import { Switch as KSwitch, SwitchChangeEvent, SwitchProps } from '@progress/kendo-react-inputs';
import { FC, useId } from 'react';

interface KSwitchProps extends Omit<SwitchProps, 'checked'> {
  id?: string;
  value: boolean;
  onChange: (event: SwitchChangeEvent) => void;
  label?: string;
  onLabel?: string;
  offLabel?: string;
  disabled?: boolean;
  size?: null | 'small' | 'medium' | 'large';
  className?: string;
}

const Switch: FC<KSwitchProps> = ({
  id,
  value,
  onChange,
  label,
  onLabel,
  offLabel,
  disabled,
  ...props
}) => {
  const defaultId = useId();
  const switchId = id || defaultId;

  return (
    <span>
      <label htmlFor={switchId}>
        <KSwitch
          {...props}
          onLabel={onLabel}
          offLabel={offLabel}
          checked={value}
          onChange={onChange}
          id={switchId}
          disabled={disabled}
        />
        {label && <div>{label}</div>}
      </label>
    </span>
  );
};

export default Switch;
